// Descrição real de cada ferramenta para gerar roteiro de TUTORIAL NARRADO.
// Módulo isolado — nada existente é alterado.

export type TutorialFerramenta = {
  local: string;       // onde encontrar dentro do site
  campos: string[];    // o que preencher / selecionar, em ordem
  acao: string;        // qual botão clicar
  leitura: string;     // o que aparece na tela depois
  aposta: string;      // como transformar em aposta
};

const METODOS_LOCAL = (nome: string) =>
  `Eu estou aqui na página inicial e vou no menu Métodos. Assim que a página abre, aparecem todos os métodos em cartões, e eu desço até o cartão ${nome} e clico nele para abrir a ferramenta`;

export const TUTORIAIS: Record<string, TutorialFerramenta> = {
  soma_chave_ouro: {
    local: METODOS_LOCAL("Soma Chave de Ouro"),
    campos: [
      "no primeiro campo eu digito a milhar que saiu no primeiro prêmio do último sorteio, exatamente como está no resultado, com os quatro números",
      "logo abaixo o sistema já mostra o código base fixo, que é o zero seis seis três, e esse código não muda nunca, é ele que faz a mágica do método",
    ],
    acao: "clico no botão de calcular a soma",
    leitura:
      "na hora a tela mostra a soma feita entre a milhar do resultado e o código base, e me devolve a dezena quente e o grupo correspondente àquela dezena, já com o nome do bicho do lado",
    aposta:
      "essa dezena eu jogo no grupo indicado e também na dezena seca, e se eu quiser reforçar, eu jogo a mesma dezena do primeiro ao quinto prêmio",
  },
  calculadora_chave_ouro: {
    local: METODOS_LOCAL("Calculadora Chave de Ouro"),
    campos: [
      "primeiro eu escolho a chave regional: se eu vou jogar no Rio, eu marco a chave quatrocentos e sessenta e nove, e se eu vou jogar em São Paulo, eu marco a chave trezentos e oitenta e cinco",
      "depois eu digito o resultado do último sorteio no campo indicado",
      "e escolho qual das quatro operações eu quero usar, soma, subtração, multiplicação ou divisão, porque cada operação abre um caminho diferente de palpite",
    ],
    acao: "clico em calcular",
    leitura:
      "a calculadora devolve os números encontrados em cada operação, com a dezena, a centena e o grupo de cada um deles",
    aposta:
      "eu pego os dois números que mais se repetem entre as operações e jogo esses dois no grupo e na dezena, que é onde o retorno costuma vir mais rápido",
  },
  ia_bicho: {
    local: METODOS_LOCAL("Sistema IA Bicho"),
    campos: [
      "aqui aparece uma grade de preenchimento com os prêmios de PPT até COR, então eu vou preenchendo linha por linha com os resultados dos últimos sorteios do dia",
      "eu preencho do primeiro ao sétimo prêmio de cada horário, e é importante colocar tudo certinho, porque a análise se baseia na repetição desses números",
    ],
    acao: "clico no botão de gerar a previsão",
    leitura:
      "o sistema analisa a tendência de repetição e mostra os grupos com maior chance de repetir no próximo sorteio, já excluindo o grupo que acabou de sair",
    aposta:
      "eu jogo os grupos apontados no próximo horário, nunca no horário que já passou, porque a lógica aqui é sempre olhar para a frente",
  },
  achar_centena_dia: {
    local: METODOS_LOCAL("Achar Centena do Dia"),
    campos: [
      "eu informo o resultado do primeiro prêmio do sorteio mais recente",
      "e confiro se a data está certa, porque a ferramenta trabalha em cima do dia corrente",
    ],
    acao: "clico em achar a centena",
    leitura: "a tela devolve a centena mais provável do dia e o grupo em que ela cai",
    aposta:
      "eu jogo essa centena no primeiro prêmio e também do primeiro ao quinto, que é como eu costumo proteger a aposta",
  },
  centena_matadora: {
    local: METODOS_LOCAL("Centena Matadora"),
    campos: [
      "eu coloco o resultado do último sorteio nos campos que aparecem na tela",
    ],
    acao: "clico em gerar as centenas",
    leitura:
      "o sistema faz o cruzamento e me entrega três centenas fortes, uma embaixo da outra, com o grupo de cada uma",
    aposta:
      "eu jogo as três centenas do primeiro ao quinto prêmio, dividindo o valor entre elas para cobrir mais chances",
  },
  centenas_viciadas: {
    local: METODOS_LOCAL("Centenas Viciadas"),
    campos: [
      "aqui eu só escolho o período que eu quero analisar e a loteria",
    ],
    acao: "clico em analisar",
    leitura:
      "a ferramenta lista as centenas que mais estão repetindo nos resultados, da mais viciada para a menos viciada",
    aposta:
      "eu pego as três primeiras da lista e jogo elas no próximo sorteio, junto com o grupo de cada uma",
  },
  bio_numerico: {
    local: METODOS_LOCAL("Bio Numérico Stellar"),
    campos: [
      "eu digito o meu nome completo",
      "e a minha data de nascimento no campo de data",
    ],
    acao: "clico em calcular o meu mapa",
    leitura:
      "a ferramenta calcula o número pessoal e mostra a dezena, o grupo e o bicho ligados ao meu mapa",
    aposta:
      "esse é um palpite pessoal, então eu jogo ele fixo por alguns dias, no grupo e na dezena",
  },
  numerologia_nome: {
    local: METODOS_LOCAL("Numerologia do Nome"),
    campos: [
      "eu digito o nome completo da pessoa, sem abreviar",
    ],
    acao: "clico em calcular",
    leitura:
      "aparece o número reduzido do nome, a dezena correspondente e o grupo do bicho daquele número",
    aposta:
      "eu jogo o grupo indicado no próximo sorteio e a dezena junto, para dobrar a chance de retorno",
  },
  metodo_777: {
    local: METODOS_LOCAL("Método 777"),
    campos: [
      "eu informo a milhar do primeiro prêmio do último resultado",
    ],
    acao: "clico em gerar a sequência",
    leitura:
      "o método monta a sequência triplicada e mostra as dezenas e os grupos que saem dessa combinação",
    aposta:
      "eu jogo as dezenas geradas do primeiro ao quinto prêmio, e o grupo mais forte da lista eu reforço no primeiro",
  },
  cruz_dia: {
    local: METODOS_LOCAL("Método Cruz do Dia"),
    campos: [
      "eu preencho a linha horizontal com os resultados do dia",
      "e a coluna vertical com os prêmios que a tela pede",
    ],
    acao: "clico em cruzar",
    leitura:
      "no centro da cruz aparece a dezena que o método aponta, com o grupo correspondente",
    aposta:
      "essa dezena do centro é a aposta principal, e as dezenas das pontas eu uso como reforço",
  },
  sequencia: {
    local: METODOS_LOCAL("Método Sequência"),
    campos: [
      "eu escolho quantos sorteios eu quero que a ferramenta olhe para trás",
      "e informo a loteria que eu vou jogar",
    ],
    acao: "clico em buscar sequências",
    leitura:
      "a tela mostra as sequências ocultas que se repetiram e qual é o próximo número dentro de cada sequência",
    aposta:
      "eu jogo o próximo número de cada sequência no sorteio seguinte, sempre no próximo, nunca conferindo para trás",
  },
  sete_grupos: {
    local: METODOS_LOCAL("Sete Grupos Dezenas"),
    campos: [
      "eu confiro na tela os sete grupos que estão mais quentes no momento",
      "e marco se eu quero jogar em grupo ou em dezena",
    ],
    acao: "clico em montar o jogo",
    leitura:
      "o sistema monta o jogo com os sete grupos e mostra as quatro dezenas de cada grupo",
    aposta:
      "eu jogo os sete grupos no primeiro prêmio, ou, se eu quiser gastar menos, escolho os três primeiros da lista",
  },
  esquema_infalivel: {
    local: METODOS_LOCAL("Esquema Infalível"),
    campos: [
      "eu escolho as dezenas que eu quero colocar dentro do esquema",
      "e defino quantos prêmios eu quero cobrir",
    ],
    acao: "clico em gerar o fechamento",
    leitura:
      "o esquema mostra todas as combinações fechadas, já organizadas para eu levar na banca",
    aposta:
      "eu levo o fechamento inteiro se o valor couber, e se não couber eu jogo só as combinações que aparecem no topo",
  },
  desdobramento_jb: {
    local: METODOS_LOCAL("Desdobramento JB"),
    campos: [
      "eu digito as dezenas que eu quero desdobrar",
      "e escolho o tipo de desdobramento na tela",
    ],
    acao: "clico em desdobrar",
    leitura:
      "aparece a lista completa de jogos desdobrados, com a quantidade de jogos e o custo aproximado",
    aposta:
      "eu jogo o desdobramento inteiro no próximo sorteio, porque é ele que cobre mais possibilidades",
  },
  soma_bahia: {
    local: METODOS_LOCAL("Soma Bahia"),
    campos: [
      "eu coloco os resultados que a ferramenta pede nos campos da Bahia",
    ],
    acao: "clico em somar",
    leitura:
      "o método faz a soma regional e devolve a dezena e o grupo apontados",
    aposta:
      "eu jogo essa dezena no próximo sorteio da Bahia e também no grupo correspondente",
  },
  dezenas_premiadas: {
    local: METODOS_LOCAL("Dezenas Premiadas"),
    campos: [
      "eu escolho o período de análise, normalmente os últimos trinta dias",
    ],
    acao: "clico em listar",
    leitura:
      "a tela mostra o ranking das dezenas que mais saíram, com a quantidade de vezes de cada uma",
    aposta:
      "eu pego as cinco primeiras dezenas e jogo elas do primeiro ao quinto prêmio",
  },
  centena_bichos: {
    local: METODOS_LOCAL("Centena dos Bichos"),
    campos: [
      "eu seleciono o grupo do bicho que eu quero analisar",
    ],
    acao: "clico em gerar as centenas",
    leitura:
      "a ferramenta mostra as centenas ligadas àquele grupo que estão saindo com mais força",
    aposta:
      "eu jogo a centena do topo e o grupo do bicho junto, que é a combinação que mais paga",
  },
  palpites_ia: {
    local:
      "Eu vou no menu e clico em Palpites IA, que é a página de gerar jogos",
    campos: [
      "primeiro eu escolho a loteria em que eu vou jogar",
      "depois eu escolho a inteligência artificial que vai analisar, e cada uma tem um jeito de pensar diferente",
      "e defino quantos palpites eu quero receber",
    ],
    acao: "clico no botão de gerar palpites",
    leitura:
      "em poucos segundos aparecem os palpites em cartões, cada um com a milhar, a centena, a dezena e o grupo do bicho",
    aposta:
      "eu jogo esses palpites no próximo sorteio e depois volto no histórico para conferir, porque o sistema só confere sorteios que vieram depois da geração",
  },
  estatisticas: {
    local: "Eu clico em Estatísticas no menu principal",
    campos: [
      "lá em cima eu ativo a análise avançada, que abre um painel escondido com todos os filtros",
      "eu escolho a fonte, que pode ser Paratodos Rio ou Federal",
      "escolho os prêmios que eu quero analisar, do primeiro ao quinto ou do primeiro ao sétimo",
      "marco os dias da semana e o turno, quando eu estiver olhando o Paratodos",
    ],
    acao: "confiro os rankings que aparecem na tela",
    leitura:
      "aqui eu vejo o que mais saiu, o que está atrasado, o que está esquentando, e no raio-x do bicho eu clico em um dos vinte e cinco bichos e ele me mostra a dezena mais forte daquele bicho, a centena e a milhar mais provável",
    aposta:
      "eu junto o bicho mais atrasado com a dezena mais forte dele e monto o meu jogo em cima disso",
  },
  resultados: {
    local: "Eu abro a página de Resultados no menu",
    campos: [
      "eu escolho a data que eu quero ver",
      "e o horário do sorteio, de PPT até COR",
    ],
    acao: "acompanho a tabela que carrega na tela",
    leitura:
      "a tabela traz do primeiro ao sétimo prêmio, com a milhar e o grupo do bicho de cada prêmio, tudo atualizado",
    aposta:
      "eu uso esses resultados como base para alimentar os métodos e gerar o palpite do próximo horário",
  },
  puxadas: {
    local: "Eu clico em Puxadas no menu",
    campos: [
      "eu digito a milhar ou o grupo que saiu no resultado",
    ],
    acao: "clico em gerar as puxadas",
    leitura:
      "a ferramenta lista automaticamente as puxadas daquele número, com os grupos que costumam vir depois",
    aposta:
      "eu jogo as duas ou três primeiras puxadas no próximo horário, que é quando elas costumam responder",
  },
  software_turbinado: {
    local: "Eu abro o Software Turbinado no menu",
    campos: [
      "eu escolho quantos dias de resultado o software vai analisar",
      "escolho a loteria e a quantidade de jogos que eu quero",
      "e, se eu quiser, eu fixo alguma dezena que eu já confio",
    ],
    acao: "clico em gerar os jogos",
    leitura:
      "o software cruza os últimos resultados e monta a lista de jogos prontos, com dezena, centena e grupo em cada linha",
    aposta:
      "eu levo essa lista para a banca e jogo tudo no próximo sorteio, e depois acompanho o histórico dentro do próprio sistema",
  },
  guru_chat: {
    local: "Eu clico no Guru Chat, que abre direto na conversa",
    campos: [
      "eu escrevo o que eu quero na caixa de mensagem, por exemplo, me dá três grupos para o próximo sorteio do Rio",
      "e posso escolher o modo do Guru antes de mandar",
    ],
    acao: "mando a mensagem",
    leitura:
      "o Guru responde com os grupos, as dezenas e a explicação de por que ele escolheu cada um, sempre citando o número do grupo junto com o nome do bicho certo",
    aposta:
      "eu jogo o que ele indicou no próximo sorteio e posso continuar perguntando para refinar o palpite",
  },
  vitrine: {
    local: "Eu abro a Vitrine de Métodos no menu",
    campos: [
      "eu uso os filtros para achar o tipo de método que eu quero",
    ],
    acao: "clico no cartão do método que me interessou",
    leitura:
      "abre a demonstração do método e eu consigo ver como ele funciona antes de usar",
    aposta:
      "quando eu gosto de um, eu vou direto para a ferramenta e gero o meu palpite",
  },
  loterias: {
    local: "Eu clico em Loterias Caixa no menu",
    campos: [
      "eu escolho a loteria, Mega-Sena, Lotofácil, Quina ou as outras",
      "escolho quantos jogos eu quero",
      "e se eu quiser eu fixo alguns números e monto um fechamento",
    ],
    acao: "clico em gerar",
    leitura:
      "aparecem os jogos prontos com o custo total já calculado embaixo",
    aposta:
      "eu jogo esses volantes no próximo concurso e guardo a planilha dentro do sistema",
  },
  institucional: {
    local: "Eu entro no IA Palpite Guru e mostro a página inicial",
    campos: [
      "no menu de cima estão todas as áreas, Métodos, Estatísticas, Resultados, Palpites IA e o Guru Chat",
    ],
    acao: "vou passando por cada área para mostrar o que tem dentro",
    leitura:
      "cada ferramenta trabalha em cima dos resultados reais do Jogo do Bicho, do Paratodos Rio e da Federal",
    aposta:
      "eu monto o meu jogo do dia combinando duas ou três ferramentas e sempre aposto no próximo sorteio",
  },
};

// Frases de apoio para alongar a narração até o tempo alvo, sem virar enrolação.
export const TRANSICOES_TUTORIAL: string[] = [
  "Repara comigo aqui na tela, porque esse detalhe é o que muita gente deixa passar.",
  "Presta atenção que eu vou fazer devagar para você conseguir repetir aí no seu celular.",
  "Isso aqui funciona igual no computador e no celular, a tela só muda um pouquinho de tamanho.",
  "Se você errar alguma coisa, é só limpar o campo e preencher de novo, não tem problema nenhum.",
  "Eu sempre faço isso antes de sair para apostar, porque assim eu não jogo no achismo.",
  "Uma coisa importante: eu nunca uso essa análise para sorteio que já passou, sempre para o próximo.",
  "Enquanto carrega, eu já vou te explicando o que vai aparecer.",
  "Quem é assinante consegue fazer isso quantas vezes quiser, sem limite.",
  "Esse mesmo caminho serve para as outras ferramentas do sistema, muda só a tela.",
  "Anota esses números aí, porque no final do vídeo eu vou juntar tudo em um jogo só.",
  "Isso que você está vendo é resultado real, não é exemplo inventado.",
  "Se você fizer isso todo dia, em pouco tempo você começa a enxergar o padrão sozinho.",
];
